import { ArrowLeft } from 'lucide-react';
import Link from 'next/link';
import * as React from 'react';

import { cn } from '@/lib/utils';

function PageHeader({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 max-xs:gap-2 sm:flex-row sm:items-center sm:justify-between',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

function PageHeaderTitle({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h1
      className={cn('text-2xl font-bold max-xs:text-xl max-xs:leading-tight', className)}
      {...props}
    >
      {children}
    </h1>
  );
}

function PageHeaderDescription({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('text-sm text-muted-foreground', className)} {...props}>
      {children}
    </div>
  );
}

function PageHeaderActions({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('flex items-center gap-2 shrink-0', className)} {...props}>
      {children}
    </div>
  );
}

function PageHeaderBack({ href, label = 'Go back' }: { href: string; label?: string }) {
  return (
    <Link
      href={href}
      aria-label={label}
      className={cn(
        'flex items-center justify-center shrink-0',
        'min-h-[44px] min-w-[44px] rounded-xl',
        'bg-muted/50 hover:bg-muted',
        'active:scale-95',
        'transition-all duration-200',
      )}
    >
      <ArrowLeft className="h-5 w-5 text-muted-foreground" aria-hidden="true" />
    </Link>
  );
}

export { PageHeader, PageHeaderActions, PageHeaderBack, PageHeaderDescription, PageHeaderTitle };
